import { Descendant } from "slate";
import { elementTypes } from "./constants";

export const isAddAllowed = (element: Descendant) => {
  return "type" in element && elementTypes.includes(element.type);
};
